export default "__VITE_ASSET__C0SzVzi3__";